import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Str from "shared/components/Str";
import {
	selectedOptionOnNavBarEvent,
} from "./analytics";
import LikesIcon from "./icons/Likes.svg";

const LikesLink = ({ isSelected, likesCount }) => (
	<a
		href="/who-likes-you"
		className="navbar-link"
		id="nav_ratings"
		onClick={() => {
			selectedOptionOnNavBarEvent("Likes");
		}}
	>
		<div className="navbar-link-icon-container" >
			<LikesIcon
				className={classnames("navbar-icon", {
					"navbar-icon-selected": isSelected,
				})}
				width={24}
				height={24}
			/>
			{/**
				The likesCount is jQuery-ed in via InstantEvents
				need id="navbar-ratings", nav_ratings_badge
				& span, className="count".  likesCount will always be null
				but leaving this in here to show what the dom looks like.
			*/}
			<div id="navbar-ratings">
				{
					likesCount
						? (
							<div id="nav_ratings_badge" className="navbar-likes-count">
								<span className="count">
									{likesCount > 99 ? "99+" : likesCount}
								</span>
							</div>
						)
						: null
				}
			</div>
			<div
				className={classnames("navbar-underline", {
					"navbar-underline-selected": isSelected,
				})}
			/>
		</div>
		<span className="navbar-text">
			<Str>Likes</Str>
		</span>
	</a>
);

LikesLink.defaultProps = {
	isSelected: false,
	likesCount: null,
};


LikesLink.propTypes = {
	isSelected: PropTypes.bool,
	likesCount: PropTypes.number,
};

export default LikesLink;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/LikesLink.jsx